import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-rating', 'navigateArrow', 'Use arrow keys to give grade.');
